<dx-button
  text="Create Column"
  stylingMode="contained"
  type="default"
  (onClick)="createColumn()"
>
</dx-button>

<div
  *ngIf="
    showColumn0ValueAlert ||
    showFromToOverlapAlert ||
    showColumnAlreadyExistsAlert
  "
  style="margin-top: 10px; gap: 5px"
  class="d-flex flex-column"
>
  <app-alert
    *ngIf="showFromToOverlapAlert"
    type="error"
    icon="dx-icon-warning"
    [message]="formatMessage('option.optionPriceInformation.validate.overlap')"
  ></app-alert>

  <app-alert
    *ngIf="showColumn0ValueAlert"
    type="error"
    icon="dx-icon-warning"
    [message]="formatMessage('option.optionPriceInformation.validate.noValue')"
  ></app-alert>

  <app-alert
    *ngIf="showColumnAlreadyExistsAlert"
    type="error"
    icon="dx-icon-warning"
    [message]="
      formatMessage('option.optionPriceInformation.validate.alreadyExists')
    "
  ></app-alert>
</div>

<dx-data-grid
  id="gridContainer"
  class="carton-grid"
  [dataSource]="optionData.optionPriceInformation"
  [showBorders]="true"
  [wordWrapEnabled]="true"
  (onRowUpdated)="onUpdateDeleteCreate()"
  (onRowInserted)="onUpdateDeleteCreate()"
  (onRowRemoved)="onUpdateDeleteCreate()"
  (onRowPrepared)="validateColumnCells()"
>
  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-editing
    mode="form"
    [form]="{
      labelMode: 'floating',
      colCount: 2,
      customizeItem: customizeFormItems
    }"
    [allowUpdating]="true"
    [allowAdding]="true"
    [allowDeleting]="true"
  >
  </dxo-editing>

  <dxi-column *ngIf="isFromColumnVisible()" dataField="from" dataType="number">
    <dxi-validation-rule
      type="custom"
      [validationCallback]="validateFromAndTo"
      [reevaluate]="true"
      [message]="formatMessage('option.optionPriceInformation.validate.from')"
    >
    </dxi-validation-rule>
    <dxi-validation-rule
      type="pattern"
      [pattern]="numberPattern"
      [message]="formatMessage('validation.numericOnly')"
    >
    </dxi-validation-rule>
    <dxi-validation-rule
      type="required"
      [message]="formatMessage('validation.required')"
    ></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    dataField="to"
    dataType="number"
    [caption]="isFromColumnVisible() ? 'To' : 'Pages'"
  >
    <dxi-validation-rule
      type="custom"
      [validationCallback]="validateFromAndTo"
      [reevaluate]="true"
      [message]="formatMessage('option.optionPriceInformation.validate.to')"
    >
    </dxi-validation-rule>
    <dxi-validation-rule
      type="pattern"
      [pattern]="numberPattern"
      [message]="formatMessage('validation.numericOnly')"
    >
    </dxi-validation-rule>
    <dxi-validation-rule
      type="required"
      [message]="formatMessage('validation.required')"
    ></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    *ngFor="let columnName of optionData.columns; let i = index"
    [dataField]="getDatafield(i)"
    [caption]="formatColumnCaption(columnName)"
    headerCellTemplate="headColumnsTemplate"
    [allowSorting]="false"
  >
    <dxi-validation-rule
      type="pattern"
      [pattern]="numberPattern"
      [message]="formatMessage('validation.numericOnly')"
    >
    </dxi-validation-rule>
    <dxi-validation-rule
      type="required"
      [message]="formatMessage('validation.required')"
    ></dxi-validation-rule>
  </dxi-column>

  <div
    *dxTemplate="let data of 'headColumnsTemplate'"
    class="custom-col d-flex align-items-center"
    style="justify-content: start"
  >
    <p style="margin: 0">{{ data.column.caption }}</p>
    <p class="d-flex">
      <dx-button
        stylingMode="contained"
        icon="edit"
        (onClick)="editColumn(data)"
        class="col-btn"
        hint="Rename Column"
      >
      </dx-button>
      <dx-button
        stylingMode="contained"
        icon="trash"
        (onClick)="showColumnConfirmationDialog(data)"
        class="col-btn"
        hint="Delete Column"
      >
      </dx-button>
    </p>
  </div>
</dx-data-grid>

<app-matrix-column-form-popup
  [(visible)]="columnFormPopupVisible"
  [columnForm]="columnFormData"
  [optionData]="optionData"
  [formCaption]="formCaption"
  (onSave)="saveColumnData($event)"
></app-matrix-column-form-popup>
<app-confirmation-dialog
  [title]="formatMessage('option.column.delete.title')"
  [message]="columnDialogMessage"
  [(visible)]="columnDialogVisible"
  [confirmButtonText]="'Delete Column'"
  (onConfirm)="deleteColumnData(columnDialogData)"
></app-confirmation-dialog>
